<button class="valben-dialog-close" mat-dialog-close aria-label="Zatvori">
    <mat-icon>close</mat-icon>
</button>

<h2 mat-dialog-title class="history-dialog-title">
    <mat-icon aria-hidden="true">history</mat-icon>
    <span>Prikaz povijesti</span>
</h2>

<mat-dialog-content class="history-dialog-content !max-h-[75vh] !p-0">
    <div class="history-dialog-body">
        @if (loading()) {
            <p class="text-lg">Učitavanje...</p>
        }
        @if (error()) {
            <p class="text-lg">{{ error() }}</p>
        }

        @if (!loading() && !error()) {
            <ng-container [ngSwitch]="collection()">
                <valben-survey-history *ngSwitchCase="'surveys'" [values]="historyEntities()" />
                <valben-benefits-history *ngSwitchCase="'benefits'" [values]="historyEntities()" />
                <valben-categories-history *ngSwitchCase="'categories'" [values]="historyEntities()" />
                <valben-locations-history *ngSwitchCase="'locations'" [values]="historyEntities()" />
                <valben-awards-history *ngSwitchCase="'awards'" [values]="historyEntities()" />
                <valben-news-history *ngSwitchCase="'news'" [values]="historyEntities()" />
                <valben-perks-history *ngSwitchCase="'perks'" [values]="historyEntities()" />
                <valben-prom-content-history *ngSwitchCase="'promotionalContent'" [values]="historyEntities()" />
                <ng-container *ngSwitchDefault>
                    @if (collection().length > 0) {
                        <div>Greška pri dohvaćanju povijesti</div>
                    }
                </ng-container>
            </ng-container>
        }
    </div>
</mat-dialog-content>
